import { Injectable } from '@angular/core'
import { Store } from '@ngrx/store'

import * as fromStore from '../../chat/store/index'
import * as Chat from '../../chat/store/actions/chat.actions'

import { environment } from '../../../environments/environment'
import { TypingUser } from '../conversation/typing.user'

@Injectable()
export class TypingService {

  private stopTypingTimers: { [id: string]: any } = {}

  constructor(private store: Store<fromStore.ChatState>) {
  }

  /*
    Schedules dispatching of fallback stop typing action
   */
  startTyping(typingUser: TypingUser, isUser: boolean) {
    this.store.dispatch(new Chat.StartTypingReceived({typingUser, isUser}))
    this.clearTimer(typingUser)
    this.createTimer(typingUser, isUser)
  }

  /*
    Clears waiting fallback stop typing action if any and dispatches immediate stop typing action
   */
  stopTyping(typingUser: TypingUser, isUser: boolean) {
    this.clearTimer(typingUser)
    this.dispatchStopTyping(typingUser, isUser)
  }

  private clearTimer(typingUser: TypingUser) {
    const id = this.getId(typingUser)
    const stopTypingTimer = this.stopTypingTimers[id]
    if (stopTypingTimer) {
      clearTimeout(stopTypingTimer)
      delete this.stopTypingTimers[id]
    }
  }

  private createTimer(typingUser: TypingUser, isUser: boolean) {
    const id = this.getId(typingUser)
    this.stopTypingTimers[id] = setTimeout(() => this.dispatchStopTyping(typingUser, isUser), environment.chat.stopTypingFallback)
  }

  private dispatchStopTyping(typingUser: TypingUser, isUser: boolean) {
    this.store.dispatch(new Chat.StopTypingReceived({typingUser, isUser}))
  }

  private getId(typingUser: TypingUser) {
    return `[${typingUser.conversationId}] ${typingUser.id}`
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/signalR/typing.service.ts